import router from "../router/index";

export const vueGtmConfig = {
  id: process.env.VUE_APP_GOOGLE_TAG_MENAGER_ID,
  enabled: false,
  debug: !process.env.production,
  loadScript: true,
  vueRouter: router
};
